module.exports = __webpack_public_path__ + "static/media/d1p.9e37e883.jpg";